import * as agGrid from 'ag-grid-community';
import { LicenseManager } from 'ag-grid-enterprise';
import 'ag-grid-enterprise';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import annotationPlugin from 'chartjs-plugin-annotation';
import { ChartType, TooltipPositionerFunction, Chart, registerables } from 'chart.js';
import { emptyChartPlugin } from './shared/chartjs';
import tinymce from 'tinymce';
import { initialiseAgGridWithAngular1 } from './AngularJS/AgGrid/ag-grid-angular1-support';

declare module 'chart.js' {
    interface TooltipPositionerMap {
        customPositionerCalibration: TooltipPositionerFunction<ChartType>;
    }
}

(() => {
    if (environment.production) {
        enableProdMode();
    }

    // initialize ag-Grid
    /* eslint max-len: off */
    LicenseManager.setLicenseKey("CompanyName=Clearview Business Intelligence , LLC,LicensedApplication=Clearview,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=16,LicensedProductionInstancesCount=13,AssetReference=AG-038912,SupportServicesEnd=8_April_2024_[v2]_MTcxMjUzMDgwMDAwMA==da13bb0a7801d5c96f690f6c81a4872c");

    window['Chart'] = Chart;
    Chart.register(emptyChartPlugin);
    Chart.register(ChartDataLabels);
    Chart.register(annotationPlugin);
    Chart.register(...registerables);
    window['tinymce'] = tinymce;

    const compilerOptions = { ngZoneEventCoalescing: true };

    if (window['angular']) { // AngularJS support
        window['agGrid'] = agGrid;
        initialiseAgGridWithAngular1(angular);

        angular.element(() => {
            platformBrowserDynamic().bootstrapModule(AppModule, compilerOptions).then(() => {
                angular.bootstrap(document.getElementById('ClearViewApp'), ['ClearViewApp']);
            });
        });
    } else {
        $(() => platformBrowserDynamic().bootstrapModule(AppModule, compilerOptions));
    }
})();
